<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;" v-if="only_view != true">
      <h4 class="page-title">
        <i class="fas fa-paste"></i>
        로그
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WEBCastle</a>
        </li>
        <li class="separator">
          <i class="fa fa-angle-right"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Log</a>
        </li>
      </ul>
    </div>
    <b-card v-if="show" :style="custom_style ? custom_style : ''">
      <b-row v-if="only_view == true && !summary">
        <b-col class="title">
          탐지 / 차단 로그
        </b-col>
      </b-row>
      <hr v-if="only_view == true && !summary">
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="6">
            <!-- <b-form-group>
              <label for="opt_from"> Detected_at
                <b-button size="sm" variant="info" @click="set_sd('', 'created_at')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'created_at')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'created_at')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'created_at')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'created_at')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'created_at')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="reload()" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="reload()" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group> -->
          </b-col>
          <!-- <b-col md="6">
            <b-form-group>
              <label for="opt_end"> To
                <b-button size="sm" variant="info" @click="set_sd('', 'created_at_ed')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d', 'created_at_ed')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w', 'created_at_ed')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m', 'created_at_ed')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w', 'created_at_ed')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m', 'created_at_ed')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="reload()" v-model="so.opt.updated_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="reload()" v-model="so.opt.updated_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col> -->
        <!-- </b-row>
        <b-row> -->

        </b-row>
        <b-row>
          <b-col md="4">
            <b-form-group>
              <label for="opt_rule_id">정책 ID</label>
              <b-form-input placeholder="정책 id 부분을 입력하세요" @keydown.enter="reload()" type="text" id="opt_rule_id" v-model="so.opt['m_id']"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label for="opt_is_block">대응</label>
              <br>
              <select v-model="so.opt['is_block']" @change="reload()">
                <option value="">대응을 선택하세요</option>
                <option value="false">DetectionOnly</option>
                <option value="true">Block</option>
              </select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label for="opt_method">Method</label>
              <br>
              <select v-model="so.opt['method']" @change="reload()">
                  <option value="">메소드를 선택하세요</option>
                  <option value="GET">GET</option>
                  <option value="POST">POST</option>
                </select>
            </b-form-group>
          </b-col>
          <!-- <b-col md="4">
            <b-form-group>
              <label for="opt_rule_line">Rule Line</label>
              <b-form-input @keydown.enter="reload()" type="text" id="opt_rule_line" v-model="so.opt['m_line']"></b-form-input>
            </b-form-group>
          </b-col> -->
          <!-- <b-col md="4">
            <b-form-group>
              <label for="opt_rule_file">file</label>
              <b-form-input @keydown.enter="reload()" type="text" id="opt_rule_file" v-model="so.opt['m_file']"></b-form-input>
            </b-form-group>
          </b-col> -->
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group>
              <label for="opt_headers">헤더 메세지(부분 검색 가능)</label>
              <b-form-input placeholder="헤더 부분을 입력하세요" @keydown.enter="reload()" type="text" id="opt_headers" v-model="so.opt['headers']"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group>
              <label for="opt_uri">URI ( <b-checkbox v-model="so.opt.uri_check" inline>제외</b-checkbox>)</label>
              <b-form-input placeholder="URI 부분을 입력하세요" @keydown.enter="reload()" type="text" id="opt_uri" v-model="so.opt['uri']"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group>
              <label for="opt_message">탐지 메세지(부분 검색 가능) ( <b-checkbox v-model="so.opt.message_check" inline>제외</b-checkbox>)</label>
              <b-form-input placeholder="탐지 메세지 부분을 입력하세요" @keydown.enter="reload()" type="text" id="opt_message" v-model="so.opt['message']"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <b-form-group>
              <label for="opt_attacker">공격자 ( <b-checkbox v-model="so.opt.remote_addr_check" inline>제외</b-checkbox>)</label>
              <b-form-input placeholder="공격자 부분을 입력하세요" @keydown.enter="reload()" type="text" id="opt_attacker" v-model="so.opt['remote_addr']"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label for="opt_victim">공격 대상 ( <b-checkbox v-model="so.opt.target_check" inline>제외</b-checkbox>) </label>
              <b-form-input placeholder="공격 대상 부분을 입력하세요" @keydown.enter="reload()" type="text" id="opt_victim" v-model="so.opt['target']"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label for="opt_xff">XFF ( <b-checkbox v-model="so.opt.xff_check" inline>제외</b-checkbox>) </label>
              <b-form-input placeholder="XFF 부분을 입력하세요" @keydown.enter="reload()" type="text" id="opt_xff" v-model="so.opt['xff']"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <hr class="w-80">
        <b-row>
          <b-col md="12">
            <b-form-group>
              <RuleCountry
                ref="_country"
                class="animated fadeIn fadeOut"
                gchart_id="_gchart_log_ko"

                :origin="country_code"
                :origin_use_geoip="use_geoip"
                :_show_toogle_button="false"
                :db_update_available="false"
                :hide_count="true"
                :use_geoip="true"
                :only_select_custom="true"
                :geo_reset="geo_reset"

                name="country_code"
                @update="($val, key) => country_code = $val"
                @use_geoip="($val, key) => use_geoip = $val"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <hr>
        <b-row v-if="options && options.length" class="text-center">
          <b-col>
            사용자 지정 선택
          </b-col>
          <b-col>
            <b-form-group>
              <b-form-checkbox-group
                v-model="selected"
                :options="options"
                button-variant="info"
                name="option"
                buttons
                style="color: #fff !important;"
              ></b-form-checkbox-group>
            </b-form-group>
          </b-col>
          <b-col md="4">
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col md="6">
            <label for="ph_search_opt_type">검색 옵션</label>
            <b-form-group>
              <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
                <b-form-radio value="and">[AND]:모두 포함</b-form-radio>
                <b-form-radio value="or">[OR]:하나라도 포함</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group class="float-right">
              <b-button :disabled="downloading" title="* Can search interval 6 months." v-b-tooltip.hover @click="download()" size="sm" variant="success" class="button-add">
                <i v-if="downloading" class="fa fa-refresh fa-spin mr-2"></i>
                csv 다운로드
              </b-button>
              <b-button size="sm" variant="success" @click="reload()"> 검색 </b-button>
              <b-button class="btn-add" size="sm" variant="warning" @click="reset"> 초기화 </b-button>
              <b-button size="sm" variant="secondary" @click="search_opt"> 닫기 </b-button>
            </b-form-group>
        </b-col>
      </b-row>
      </b-card>
      <!-- detail search end -->
      <b-row class="text-center mb-3">
        <b-col md="3" class="title text-left" v-if="custom_title">
          {{custom_title}}
        </b-col>
        <b-col sm="3" md="3" v-if="!summary">
          표시 수
          <select v-model="so.perPage" @change="refresh">
            <option value="15">표시 수 : 기본 15</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </b-col>
        <b-col sm="2" md="2" v-if="!summary">
        </b-col>
        <b-col>
          <span>
            실시간
            <span v-if="summary == true">최근 로그</span>
          </span>
          <b-form-checkbox
            :checked="sync.run"
            class="d-inline-block ml-4"
            name="check-button"
            switch
            v-on:change="toggle"

          ></b-form-checkbox>
          <b-btn v-if="summary == true" variant="outline-secondary" @click="reload()"><i class="fa fa-refresh"></i></b-btn>
          <!-- <c-switch class="pt-2 ml-2" color="success" label variant="pill" v-on:click="toggle()" /> -->

          <span v-if="!only_view && auto_refresh != false">
            <select v-model="sync.interval" @change="refresh" :disabled="!sync.run">
              <option value="15">새로고침 : 15</option>
              <option value=10>10</option>
              <option value=30>30</option>
              <option value=60>60</option>
              <option value=300>300(5 분)</option>
            </select>
            <span v-b-tooltip.hover title="can see the log real-time">초</span>
          </span>
          <span v-if="only_view" class="float-right mt-2">
            <i v-b-tooltip.hover title="목록으로 이동합니다" v-if="only_view" @click="$router.push({ name: 'webcastle_log'})" style="margin: 0px 10px; color:blue; border:1px solid skyblue; border-radius:5px; padding: 5px; background-color:skyblue; width: 25px; height:25px; font-size:12px; cursor:pointer;" class="fa">&#xf142;</i>
          </span>
        </b-col>
        <!-- <b-col sm="3" md="3" v-if="only_view != true">
          <b-form-checkbox
            :title="`recommended to a minimum width of ${max_width}px`"
            v-b-tooltip.hover
            :disabled="!can_split_view"
            class="mt-2"
            v-model="is_half_mode"> 분할 보기 </b-form-checkbox>
        </b-col> -->
      </b-row>
      <hr v-if="only_view != true">
      <b-row v-if="only_view != true">
        <b-col>
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="reload()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :disabled="so.adv" :text="so.skt || '검색'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='remote_addr';so.skt=`공격자`">공격자</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='target';so.skt=`대상`">대상</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='message';so.skt='메세지'">메세지</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='m_id';so.skt='정책 ID'">정책 ID</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='uri';so.skt='URI'">URI</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-form-input :disabled="so.adv" v-model="so.sv" @keyup.native.enter="reload"></b-form-input>
            <b-input-group-append>
              <b-btn :disabled="so.adv" variant="outline-secondary" @click="reload()"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="() => search_opt()"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"> 상세검색</i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr v-if="only_view != true">
      <b-row v-if="only_view != true" class="text-center">
        <b-col sm="1" md="1">
          <span>
            에이전트 선택
          </span>
        </b-col>
        <b-col sm="4">
          <multiselect deselect-label="선택하면 검색에서 제외" selected-label="선택됨" @remove="reload" @select="reload" v-model="agent" select-label="에이전트를 선택하세요" placeholder="에이전트를 선택하세요" label="nickname" track-by="nickname" :options="agent_list" :multiple="true" :taggable="true" @tag="add_tag"></multiselect>
        </b-col>
        <b-col>
          <b-form inline>
            <span class="mr-2">검색 기간</span>
            <date-picker @change="$refs._wc_log_list && $refs._wc_log_list.refresh()" v-model="so.created_at_sd" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
            ~
            <date-picker @change="$refs._wc_log_list && $refs._wc_log_list.refresh()" v-model="so.created_at_ed" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>

            <!-- <b-button class="btn-insert ml-2" @click="() => { so.created_at_sd = moment().add(-1, 'day'); $refs._wc_log_list.refresh() }" size="sm" variant="info">-1</b-button> -->
            <b-button class="btn-insert ml-2" @click="() => { so.created_at_sd = moment().add(-7, 'day'); $refs._wc_log_list.refresh() }" size="sm" variant="info">-7</b-button>
            <b-button class="btn-insert ml-2" @click="() => { so.created_at_sd = moment().add(-30, 'day'); $refs._wc_log_list.refresh() }" size="sm" variant="info">-30</b-button>
          </b-form>
        </b-col>
      </b-row>
      <hr v-if="only_view != true">
      <b-row>
        <b-col :sm="is_half_mode ? 6 : 12" :md="is_half_mode ? 6 : 12" :lg="is_half_mode ? 6 : 12" :xl="is_half_mode ? 6 : 12">
          <b-table hover striped small responsive="sm" ref="_wc_log_list"
          class="table-responsive table_add"
            show-empty empty-text="최근 로그가 없습니다"
            :items="getItems"
            :fields="fields"
            :current-page="so.currentPage" :per-page="so.perPage">
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>
            <template slot="id" slot-scope="row"> {{startRow - row.index}}</template>
            <template slot="host" slot-scope="row">{{row.item.host || '-'}}</template>
            <template slot="castle" slot-scope="row">{{row.item.castle && row.item.castle.nickname ? row.item.castle.nickname : '-'}}</template>
            <template slot="created_at" slot-scope="row">{{row.item.created_at | sdatetime }}</template>
            <template slot="remote_addr" slot-scope="row">
              <span v-if="row.item.country" class="flag-icon" :class="set_flag(row.item.country)"></span>
              <span v-if="row.item.xff" class="ip">
                {{row.item.xff}}
              </span>
              <span v-else class="ip">
                {{row.item.remote_addr}}
              </span>
              <b-badge @click="info_xff = true" v-if="row.item.xff" variant='success' style='cursor: pointer;'>XFF (?)</b-badge>
            </template>
            <template slot="country" slot-scope="row">
              <span v-if="row.item.country">
                <span class="flag-icon" :class="set_flag(row.item.country)"></span>
                <span>({{ row.item.country }})</span>
              </span>
              <span v-else>
                -
              </span>
            </template>
            <template slot="target" slot-scope="row">{{row.item.target}}</template>
            <template slot="protocol" slot-scope="row">{{row.item.protocol}} {{row.item.method}}</template>
            <template slot="is_block" slot-scope="row">
              <b-badge v-if="row.item.is_block" variant="danger">차단</b-badge>
              <b-badge v-else variant="warning">탐지</b-badge>
            </template>
            <template slot="message" slot-scope="row">
              <strong v-if="row.item.is_failed">
                Parsering error, request to Support for checking
              </strong>
              <strong v-else>
                <a href="javascript:void(0)" class="a_tag" @click="detail(row.item)">
                  <span v-if="only_view">
                    {{(row.item.title_i18n ? row.item.title_i18n['KO'].desc : (temp_i18n[row.item.title] ? (temp_i18n[row.item.title] || '-') : (row.item.title ? row.item.title : '상세보기'))) | truncate(20)  }}
                  </span>
                  <span v-else>
                    {{row.item.title_i18n ? (row.item.title_i18n['KO'].desc || '-') : (temp_i18n[row.item.title] ? (temp_i18n[row.item.title] || '-') : (row.item.title ? row.item.title : '상세보기'))  }}
                  </span>
                  <!-- {{row.item.title_i18n}} -->
                  <!-- {{row.item.summary.details.i18n}} -->
                </a>
              </strong>
            </template>
            <template slot="severity" slot-scope="row">
              <span v-if="row.item.is_failed">
                -
              </span>
              <!-- 단독 개선 버전 -->
              <span v-else-if="row.item.title" class="font-weight-bold" style="display: inline-block">
                <div style="display: inline-flex">
                  <Bell v-if="row.item.sub_log_count" :size="20" :count="row.item.sub_log_count" style="position: relative; top:-5px; left:-6px; z-index:100"/>
                    <span scope="row" :style=" row.item.sub_log_count > 1 ? 'position: relative; left:0px;' : 'position: relative;left:5px;'">
                      <b-badge :variant="codes.WAF_SEVERITY_TO_COLOR_EASY(row.item.severity, 'variant')">
                        {{codes.WAF_SEVERITY_TO_DESC_EASY(row.item.severity, 'KO')}}
                      </b-badge>
                    </span>
                </div>
              </span>
              <!-- uwss 버전 -->
              <span v-else-if="row.item.message" class="font-weight-bold" style="display: inline-block">
                <div style="display: inline-flex">
                  <Bell v-if="row.item.message && row.item.message.messages.length > 1" :size="20" :count="row.item.message.messages.length" style="position: relative; top:-5px; left:-6px; z-index:100"/>
                    <span scope="row" :style=" row.item.message && row.item.message.messages.length > 1 ? 'position: relative; left:0px;' : 'position: relative;left:5px;'">
                      <b-badge :variant="codes.WAF_SEVERITY_TO_COLOR_EASY(row.item.severity, 'variant')">
                        {{codes.WAF_SEVERITY_TO_DESC_EASY(row.item.severity, 'KO')}}
                      </b-badge>
                    </span>
                </div>
              </span>
              <!-- 예외 처리 -->
              <span v-else>
                <!-- <span scope="row">
                  <b-button size="sm" :id="'tooltip_not_defined'+row.index" variant="outline-dark">
                    미정의
                  </b-button>
                  <b-tooltip :target="'tooltip_not_defined'+row.index" triggers="hover">
                    새로운 공격일 수 있습니다.
                  </b-tooltip>
                </span> -->
                <span scope="row">
                  <b-badge :id="'tooltip_not_definded' + row.index" variant="secondary">
                    미정의
                  </b-badge>
                  <b-tooltip :target="'tooltip_not_definded' + row.index" triggers="hover">
                    새로운 공격일 수 있습니다.
                  </b-tooltip>
                </span>
              </span>
            </template>

            <template slot="uri" slot-scope="row">{{autoSize() < row.item.uri.length ? row.item.uri.substring(0, autoSize()) + "..." : row.item.uri.substring(0, autoSize())}}</template>
            <template slot="func" slot-scope="row">
              <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">더 보기</b-btn>
            </template>
          </b-table>
        </b-col>
        <b-col v-show="is_half_mode" :sm="is_half_mode ? 6 : 0" :md="is_half_mode ? 6 : 0" :lg="is_half_mode ? 6 : 0" :xl="is_half_mode ? 6 : 0">
          <Detail v-if="is_half_mode" :id="id"  ref="detail"/>
        </b-col>
      </b-row>
      <hr v-if="only_view != true">
      <b-row v-if="only_view != true">
        <b-col class="md-8">
          <b-pagination size="sm" class="pagination justify-content-center" :limit="so.perPage" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">"/>
        </b-col>
      </b-row>
      <!-- bottom -->
      <b-row class="text-center" v-if="!(only_view != true) && enable_paging" style="position: absolute; bottom:20px; width:95%;">
        <b-col>
          <b-pagination size="sm" class="pagination justify-content-center" :limit="so.perPage" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" prev-text="<" next-text=">"/>
        </b-col>
      </b-row>
    </b-card>
    <b-modal size="m" title="XFF : X-Forwarded-For"  class="modal-success" v-model="info_xff" hide-footer @ok="info_xff = false">
      HTTP 프록시나 로드 밸런서를 통해 웹 서버에 접속하는 클라이언트의 원 IP 주소
    </b-modal>

    <!-- 시작 및 마지막 날짜 유무 확인 모달-->
    <b-modal title="기간 설정" size="xs" v-model="date_modal" @ok="date_modal = false" ok-variant="outline-primary" ok-only ok-title="확인">
      시작 날짜 및 마지막 날짜를 지정해야 조회가 가능합니다.
    </b-modal>

     <!-- 기간 설정 범위제한 모달-->
     <b-modal title="기간 설정" size="xs" v-model="year_modal" @ok="year_modal = false" ok-variant="outline-primary" ok-only ok-title="확인">
      로그 목록은 최대 1년단위로 조회가 가능합니다.
    </b-modal>

    <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view>
  </div>
</template>
<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
